import React from 'react';
import PaymentsCard from '../PaymentsCard/PaymentsCard';
import Tooltip from '../Tooltip/Tooltip';

export default function UpcomingPayments({ upcomingPayments }) {
  return (
    <PaymentsCard
      title="Upcoming payments"
      icon="money-bag"
      description="Upcoming Payment"
      total={upcomingPayments.upcomingJobsTotalPayment}
      img="payments_bg_layer1"
    >
      <div className="row no-gutters">
        <div className="col-6">
          <p className="text-left ml-2">Next payment date</p>
        </div>
        <div className="col-6">
          <h5 className="text-right">{upcomingPayments.nextPayment_date}</h5>
        </div>
      </div>
      <div className="row no-gutters">
        <div className="col-9">
          <p className="text-left ml-2">
            Total confirmed jobs
            <Tooltip content="Jobs need to be completed by all parties by close of play Wednesday to be included in the Friday payment." />
          </p>
        </div>
        <div className="col-3">
          <h5 className="text-right">{upcomingPayments.upcomingJobCount}</h5>
        </div>
      </div>
    </PaymentsCard>
  )
}
